import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { GetDailyCheckInDataResponse } from '@/modules/promotion/type'
import { columns, writeAccessorKeys } from './constants'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useMemo } from 'react'
import useQueryGetDailyCheckInName from '@/modules/promotion/api/hooks/useQueryGetDailyCheckInName'
import { DataTableSelector } from '@/common/ui/table/data-table-selector'

interface DailyCheckInTableProps {
	data: GetDailyCheckInDataResponse[]
	total: number
	isLoading?: boolean
}

export default function DailyCheckInTable({
	data,
	total,
	isLoading,
}: DailyCheckInTableProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_DAILY_CHECK_IN,
	)

	const { data: dailyCheckInNames } = useQueryGetDailyCheckInName()

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	const selectorOptions = useMemo(
		() =>
			(dailyCheckInNames?.data ?? []).map((promotion) => ({
				label: promotion.name,
				value: promotion.name,
			})),
		[dailyCheckInNames],
	)
	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSelector
					options={selectorOptions}
					placeholder="ค้นหาเช็คอินรายวัน"
				/>
				<DataTableResetFilter />
			</div>
			<DataTablePaginate
				columns={filteredColumns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
